import React from 'react'
import Avatar from './commons/avatar'
import { Container, ParagraphContent } from './commons/components'
import ActionButtons from './commons/action-buttons'
import PropTypes from 'prop-types'

export default function Security({
  variant,
  recipient,
  displayName,
  onConfirm,
  onCancel,
  firstName = '',
  lastName = '',
  country = '',
}) {
  return (
    <Container>
      <Avatar />
      <ParagraphContent
        style={{ marginTop: '2rem' }}
        displayName={displayName}
        recipient={recipient}
        variant={variant}
        firstName={firstName}
        lastName={lastName}
        country={country}
      />
      <ActionButtons onConfirm={onConfirm} onCancel={onCancel} />
    </Container>
  )
}

Security.propTypes = {
  recipient: PropTypes.string,
  displayName: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  country: PropTypes.string,
  variant: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}
